import React from 'react';
import './PageHeader.css';
import arrowBackIcon from './icons/arrow-back-black.svg';
import { Link, useNavigate } from "react-router-dom";
import { Avatar, Dropdown } from "antd";
import {
  CalendarOutlined,
  CommentOutlined,
  HighlightOutlined,
  NotificationOutlined,
  SisternodeOutlined,
  UserDeleteOutlined,
  UserOutlined,
  UserSwitchOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import crownIcon from "../../pages/icons/crown.png";
import { jwtDecode } from "jwt-decode";
import { authActions } from "../../store";
import { useOrganization } from "../../context/organizationContext";
import NotificationDrawer from "../Drawers/NotificationDrawer";
import { useConfirm } from "../../hooks/useConfirm"; 

const PageHeader = ({ title, onBackClick }) => {
  const { t } = useTranslation();
  const org = useOrganization();
  const user = useSelector((obj) => obj.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const confirm = useConfirm(); 
  const sid = user ? jwtDecode(JSON?.parse(localStorage?.getItem("user"))?.accessToken)?.subscriptionLevel?.id : false;

  const handleLogout = async () => {
    const ok = await confirm({
      title: t("home.logoutTitle") || t("home.logout"),
      message: t("home.logoutConfirm"),
      confirmText: t("common.yes") || "Да",
      cancelText: t("common.no") || "Нет",
    });

    if (ok) {
      dispatch(authActions.logout());
    }
  };

  const items = [
    {
      condition: true,
      key: 'username',
      label: user?.name,
      disabled: true,
    },
    { condition: true, type: 'divider' },
    {
      condition: true,
      key: 'profile',
      label: <Link to="/profile">{t("home.profile")}</Link>,
      icon: <UserSwitchOutlined />,
    },
    {
      condition: true,
      key: 'postsCalendar',
      label: <Link to="/publication-calendar">{t("home.postsCalendar")}</Link>,
      icon: <CalendarOutlined />,
    },
    {
      condition: (org?.organization?.moderatorExist && user?.moderatorOrg),
      key: 'alertsManagement',
      label: <Link to="/alerts-management">{t("home.alertsManagement")}</Link>,
      icon: <NotificationOutlined />,
    },
    {
      condition: true,
      key: 'analytics',
      label: <Link to="/analytics">{t("analytics.menu")}</Link>,
      icon: <HighlightOutlined />,
    },
    {
      condition: true,
      key: 'guideline',
      label: <Link to="/guideline">{t("home.guideline")}</Link>,
      icon: <SisternodeOutlined />,
    },
    {
      condition: true,
      key: 'support',
      label: <Link to="/support">{t("home.support")}</Link>,
      icon: <CommentOutlined />,
    },
    {
      condition: true,
      key: 'logoutConfirm',
      label: (
        <div onClick={handleLogout}>
          {t("home.logout")}
        </div>
      ),
      icon: <UserDeleteOutlined />,
    },
  ];

  return (
    <div className="header-container">
      <div className="flex items-center">
        <button
          className="back-button"
          onClick={() => (onBackClick ? onBackClick() : navigate(-1))}
        >
          <img width={35} src={arrowBackIcon} alt="" />
          <h6 className="header-title">{title}</h6>
        </button>
      </div>

      <div className="flex items-center gap-5">
        <NotificationDrawer />
        {user && (
          <div className="relative">
            {!!sid && (
              <img
                className="w-5 h-5 absolute -top-2 -right-2 z-10 !bg-transparent pointer-events-none"
                src={crownIcon}
                alt="premium"
              />
            )}
            <Dropdown
              placement="bottomRight"
              menu={{
                items: items
                  .filter((item) => item.condition)
                  .map(({ condition, ...rest }) => rest),
              }}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Avatar
                  className="cursor-pointer"
                  size={35}
                  style={{ backgroundColor: '#cab9f2', color: '#000' }}
                  icon={<UserOutlined />}
                />
              </a>
            </Dropdown>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
